/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getMedicines } from 'app/entities/medicine/medicine.reducer';
import { getEntities as getRegimenDrugs } from 'app/entities/regimen-drug/regimen-drug.reducer';
import { createEntity, getEntity, reset, updateEntity } from './dosage-dilution.reducer';

export const DosageDilutionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const medicines = useAppSelector(state => state.medicine.entities);
  const regimenDrugs = useAppSelector(state => state.regimenDrug.entities);
  const dosageDilutionEntity = useAppSelector(state => state.dosageDilution.entity);
  const loading = useAppSelector(state => state.dosageDilution.loading);
  const updating = useAppSelector(state => state.dosageDilution.updating);
  const updateSuccess = useAppSelector(state => state.dosageDilution.updateSuccess);

  const handleClose = () => {
    navigate(`/dosage-dilution${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getMedicines({}));
    dispatch(getRegimenDrugs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.diluentValue !== undefined && typeof values.diluentValue !== 'number') {
      values.diluentValue = Number(values.diluentValue);
    }
    if (values.soluteUnit !== undefined && typeof values.soluteUnit !== 'number') {
      values.soluteUnit = Number(values.soluteUnit);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...dosageDilutionEntity,
      ...values,
      solute: medicines.find(it => it.id.toString() === values.solute?.toString()),
      diluent: medicines.find(it => it.id.toString() === values.diluent?.toString()),
      regimenDrug: regimenDrugs.find(it => it.id.toString() === values.regimenDrug?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...dosageDilutionEntity,
          solute: dosageDilutionEntity?.solute?.id,
          diluent: dosageDilutionEntity?.diluent?.id,
          regimenDrug: dosageDilutionEntity?.regimenDrug?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.dosageDilution.home.createOrEditLabel" data-cy="DosageDilutionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.dosageDilution.home.createOrEditLabel">Create or edit a DosageDilution</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="dosage-dilution-id"
                  label={translate('tinyMedicRestApp.dosageDilution.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageDilution.diluentValue')}
                id="dosage-dilution-diluentValue"
                name="diluentValue"
                data-cy="diluentValue"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageDilution.diluentUnit')}
                id="dosage-dilution-diluentUnit"
                name="diluentUnit"
                data-cy="diluentUnit"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageDilution.recommendedSolute')}
                id="dosage-dilution-recommendedSolute"
                name="recommendedSolute"
                data-cy="recommendedSolute"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageDilution.soluteUnit')}
                id="dosage-dilution-soluteUnit"
                name="soluteUnit"
                data-cy="soluteUnit"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageDilution.solutetValue')}
                id="dosage-dilution-solutetValue"
                name="solutetValue"
                data-cy="solutetValue"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageDilution.active')}
                id="dosage-dilution-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageDilution.cursor')}
                id="dosage-dilution-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageDilution.lastUpdated')}
                id="dosage-dilution-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageDilution.microSec')}
                id="dosage-dilution-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.dosageDilution.timestampEntry')}
                id="dosage-dilution-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="dosage-dilution-solute"
                name="solute"
                data-cy="solute"
                label={translate('tinyMedicRestApp.dosageDilution.solute')}
                type="select"
              >
                <option value="" key="0" />
                {medicines
                  ? medicines.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="dosage-dilution-diluent"
                name="diluent"
                data-cy="diluent"
                label={translate('tinyMedicRestApp.dosageDilution.diluent')}
                type="select"
              >
                <option value="" key="0" />
                {medicines
                  ? medicines.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="dosage-dilution-regimenDrug"
                name="regimenDrug"
                data-cy="regimenDrug"
                label={translate('tinyMedicRestApp.dosageDilution.regimenDrug')}
                type="select"
              >
                <option value="" key="0" />
                {regimenDrugs
                  ? regimenDrugs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/dosage-dilution" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DosageDilutionUpdate;
